import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-table-viewer',
    standalone: false,
    templateUrl: './table-viewer.component.html',
    styleUrls: ['./table-viewer.component.scss'],
})
export class TableViewerComponent implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<TableViewerComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { table: Array<Array<string>>; csv: string },
    ) {}

    ngOnInit(): void {}

    saveCsv() {
        let csvContent = 'data:text/csv;charset=utf-8,' + this.data.csv;
        var encodedUri = encodeURI(csvContent);
        var link = document.createElement('a');
        link.setAttribute('href', encodedUri);
        link.setAttribute('download', 'termine.csv');
        document.body.appendChild(link); // Required for FF
        link.click();
    }
}
